import axios from "axios"
import { Host, seleccionmapa } from "./constantes"
import { clienteInfo, getDatosUsuariosLocalStorag } from "./DatosUsuarioLocalStorag"
export const ActualizaEstadoLocalidad = async (id, parms) => {
    let ids = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(ids),
    }
    const { data } = await axios.put("https://api.t-ickets.com/ms_login/actualizarevento_estado/" + id, { ...parms, ...parmspro }, {
        headers: {
            'Content-Type': 'application/json',
            'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
        }
    })
    return data
}
export const cargarEventoActivo = async (parms) => {
    try {
        const { data } = await axios.get("https://api.t-ickets.com/ms_login/listareventos/" + parms+"/", {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        if (data.data == 0) return null
        return data.data
    } catch (error) {
        return null

    }

}
/*
export const cargarMapa = async () => {
    try {
        const { data } = await axios.get("https://api.t-ickets.com/ms_login/listarMapas", {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
export const guardarMapar = async (parm) => {
    try {
        const { data } = await axios.post("https://api.t-ickets.com/ms_login/guardarMapa", parm, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
export const editarMapa = async (parm) => {
    try {
        const { data } = await axios.put("https://api.t-ickets.com/ms_login/actualizarMapa", parm, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
export const eliminaMapa = async (parm) => {
    try {
        const { data } = await axios.delete("https://api.t-ickets.com/ms_login/eliminarMapa/" + parm, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}*/
export const enviasilla = async (info) => {
    let user = getDatosUsuariosLocalStorag()
    let nombres = JSON.parse(sessionStorage.getItem(seleccionmapa))

    const datos = {
        id: nombres.idcolor,
        cedula: user.cedula,
        silla: info.silla,
        estado: "reservado",
    }
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    //                                      getDatosUsuariosLocalStorag
    let parmspro = {
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(id),
    }
    try {
        const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/selecionar_localidad", { ...datos, ...parmspro }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return { error: error, info: info }

    }
}
export const correlativosadd = async (parms) => {
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    //                                      getDatosUsuariosLocalStorag
    let parmspro = {
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(id),
    }
    try {
        console.log("correlativosadd", "https://api.t-ickets.com/ms_login/api/v1/selecionar_localidad_correlativa",
            { ...parms, ...parmspro }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/selecionar_localidad_correlativa",
            { ...parms, ...parmspro }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        }
        )
        
        console.log(data)
        return data
    } catch (error) {
        console.error("correlativosadd.error", {
            status: error?.response?.status,
            data: error?.response?.data,
            payload: { ...parms, ...parmspro },
        })
        return error
    }
}
export const correlativodelete = async (parms) => {
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    //                                      getDatosUsuariosLocalStorag
    let parmspro = {
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(id),
    }
    try {
        const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/selecionar_localidad_correlativa_eliminar",
            { ...parms, ...parmspro }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        }
        )
        return data

    } catch (error) {
        console.error("correlativodelete.error", {
            status: error?.response?.status,
            data: error?.response?.data,
            payload: { ...parms, ...parmspro },
        })
        return error
    }
}
/*
export const listarLocalidadaEspeci = async (parms) => {
    try {
        const { data } = await axios.get("https://api.t-ickets.com/ms_login/api/v1/listar_localidades_id_espacio_descripcion/" + parms, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}*/
export const guardarCarrusel = async (parms) => {
    try {
        const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/", parms, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error

    }
}
export const quitarsilla = async (parms) => {
    let ids = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(ids),
    }
    try {
        const { data } = await axios.put("https://api.t-ickets.com/ms_login/api/v1/quitarselecion_localidad",
            {
                ...parms,
                ...parmspro
            }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error

    }
}
export const buscarcliente = async (datos) => {
    try {
        const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/consultar_cedula", datos, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error

    }
}
// Guarda o quita (img_suscriptor: null) la foto de perfil del usuario.
export const actualizarImgSuscriptor = async (datos) => {
    try {
        const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/imgSuscriptor", datos, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
export const sumarcorrelativo = async (datos) => {
    try {
        const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/selecionar_localidad_correlativa",
            datos, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        }
        )
        return data
    } catch (error) {

    }
}

export const noticiasEvento = async (datos) => {
    try {
        const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/crear_evento_publicidad", datos, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        }
        )
        return data
    } catch (error) {

    }
}

export const AsignarAsientosManualAPI = async (parms) => {
    let ids = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    try {
        const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/asignar_asientos_manual", {
            ...parms,
            id_usuario: parseInt(idop),
            id_operador: parseInt(ids),
        }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return { success: false, message: "Error al conectar con el servidor" }
    }
}
/*
export const agregarNoticia = async (datos) => {
    try {
        const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/crear_publicidad", datos, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        }
        )
        return data
    } catch (error) {

    }
}
export const ListarNoticias = async () => {
    try {
        const { data } = await axios.get("https://api.t-ickets.com/ms_login/api/v1/listar_publicidad", {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error

    }
}
export const Actualizarpublicdad = async (id, parms) => {
    try {
        const { data } = await axios.put("https://api.t-ickets.com/ms_login/api/v1/actualizar_publicidad/" + id, parms, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
export const Eliminarpublici = async (parms) => {
    try {
        const { data } = await axios.delete("https://api.t-ickets.com/ms_login/api/v1/eliminar_publicidad/" + parms, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}*/
